import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SearchComponent } from './pages/search/search.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { SearchBoxComponent } from './components/search-box/search-box.component';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { ResultsComponent } from './pages/results/results.component';
import { HttpClientModule } from '@angular/common/http';
import { ResultsListComponent } from './components/results-list/results-list.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ButtonComponent } from './components/button/button.component';
import { DecimalPipe } from '@angular/common';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { TratamientoDatosComponent } from './components/tratamiento-datos/tratamiento-datos.component';
import { NgxTurnstileFormsModule, NgxTurnstileModule } from 'ngx-turnstile';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    BreadcrumbsComponent,
    SearchBoxComponent,
    SearchComponent,
    NumbersOnlyDirective,
    ResultsComponent,
    ResultsListComponent,
    LoaderComponent,
    TratamientoDatosComponent
],
imports: [
    ButtonComponent,
    DatePickerComponent,
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxTurnstileModule,
    NgxTurnstileFormsModule,
  ],
  providers: [DecimalPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
